import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from "clsx";
import { memo } from "react";
import { SlotsProvider } from "../providers/SlotsProvider";
import { mergeSx } from "../system";
import { Box } from "./Box";
export const overlayWrapperClasses = {
    root: "MinervaOverlayWrapper-root",
    wrapper: "MinervaOverlayWrapper-wrapper",
};
export const overlayWrapperSlots = {
    overlayWrapper: Box,
};
export const OverlayWrapper = memo(({ content, placement = { horizontal: "center", vertical: "center" }, placementOffset = { horizontal: 0, vertical: 0 }, slots, slotProps, children, className, sx, ...rest }) => {
    return (_jsx(SlotsProvider, { baseSlots: overlayWrapperSlots, slots: slots, children: ({ overlayWrapper: OverlayWrapper }) => (_jsxs(Box, { className: clsx([overlayWrapperClasses.root, className]), sx: mergeSx({
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                position: "relative",
            }, sx), ...rest, children: [children, _jsx(OverlayWrapper, { ...slotProps?.overlayWrapper, className: clsx([
                        overlayWrapperClasses.wrapper,
                        slotProps?.overlayWrapper?.className,
                    ]), sx: mergeSx({
                        [`&.${overlayWrapperClasses.wrapper}`]: {
                            position: "absolute",
                            transform: `translate(${placement.horizontal === "center" ? "-50%" : 0}, 
                                                ${placement.vertical === "center" ? "-50%" : 0})`,
                            left: placement.horizontal === "left"
                                ? placementOffset.horizontal
                                : placement.horizontal === "center"
                                    ? "50%"
                                    : "auto",
                            right: placement.horizontal === "right"
                                ? placementOffset.horizontal
                                : "auto",
                            top: placement.vertical === "top"
                                ? placementOffset.vertical
                                : placement.vertical === "center"
                                    ? "50%"
                                    : "auto",
                            bottom: placement.vertical === "bottom"
                                ? placementOffset.vertical
                                : "auto",
                        },
                    }, slotProps?.overlayWrapper?.sx), children: content })] })) }));
});
//# sourceMappingURL=OverlayWrapper.js.map